import React, { useEffect, useState } from "react";
import propTypes from "prop-types";

import { PagedDataView } from "../../../../components/lists/PagedDataView/PagedDataView";

import { api, IReportScheduleListHistory, ReportScheduleHistory } from "../../../../logic/api";

import { useDate } from "../../../../utility/useDate";

import flex from "../../../../styles/flex";
import { useTranslation } from "react-i18next";

const ScheduleHistory: React.FunctionComponent<{
    reportId: number;
    reportTargetUuid: string | undefined;
}> = (props) => {
    const defaultParams: IReportScheduleListHistory = {
        reportId: props.reportId,
        targetUuid: props.reportTargetUuid,
    }
    const [params, setParams] = useState<IReportScheduleListHistory>(defaultParams);
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();

    useEffect(() => {
        setParams(defaultParams);
    }, [props.reportId, props.reportTargetUuid]);

    return <div style={{ backgroundColor: "white", margin: 20, overflowY: "scroll", height: "calc(100vh - 170px)" }}>
        <PagedDataView<IReportScheduleListHistory, ReportScheduleHistory>
            apiHook={api.hooks.reportsSchedule.listHistory}
            animate={false}
            parameters={params}
            renderItem={(item) => {
                return <div style={{ textAlign: "left", padding: 20, borderBottom: "solid 2px dimgray" }}>
                    <div style={flex.flexRows}>
                        <div style={flex.flexAuto}>
                            <div><b>{item.schedule.name}:</b>&nbsp;</div>
                            {toFormattedDateTimeString(new Date(item.createDate))}
                        </div>
                        <div style={flex.flexFill}>
                            <div style={{ color: item.success ? "green" : "red", fontWeight: "bold" }}>
                                {item.message == null ? t("general.ok") : item.message}
                            </div>
                        </div>
                    </div>
                </div>
            }}
        ><div style={{ textAlign: "center", padding: 20 }}>
                {t("reports.noSchedReports")}
            </div>
        </PagedDataView>
    </div>
}
ScheduleHistory.propTypes = {
    reportId: propTypes.number.isRequired
}
export default ScheduleHistory;